module.exports = __webpack_public_path__ + "static/media/homeBack.7e666208.png";